import * as t from 'io-ts';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface AllowClearSettingDefinition extends CheckBoxDefinition {
    key: 'ALLOW_CLEAR';
}

const definition: AllowClearSettingDefinition = {
    key: 'ALLOW_CLEAR',
    type: 'CheckBox',
    label: 'Allow Clear',
    value: true,
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

export const AllowClearSettingDefinition = define({
    key: 'ALLOW_CLEAR',
    label: 'allowClear',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.allowClear),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.allowClear),
});
